import { formatarData, formatarPlaca } from 'src/app/core/utils/utilities';
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { UploadService } from 'src/app/services/UploadService/upload.service';
import { ITabelaCarreta } from './listagem-saida-gate-model';
import { SaidaGateService } from 'src/app/services/SaidaGateService/saidaGate.service';
import { IGetSaidasGate } from 'src/app/services/SaidaGateService/saidaGate.model';
import { IGetReportBase64 } from 'src/app/services/ReportService/report.model';
import { ImpressoraService } from 'src/app/services/ImpressoraService/impressora.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { ReportService } from 'src/app/services/ReportService/report.service';
import { decidirImpressaoPrePatio } from 'src/app/core/utils/ticket-saida-print';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-listagem-saida-gate',
  templateUrl: './listagem-saida-gate.component.html',
  styleUrls: ['./listagem-saida-gate.component.scss']
})
export class ListagemSaidaGateComponent {
  form = this.initForm();
  isLoading: boolean = false;
  numeroPagina: number = 0;
  tableData: ITabelaCarreta[] | Array<any> = [];
  maxPages: number = 1;
  expandirCardsMobile: boolean = true;
  guid = generateUUID();
  id: number = Number(localStorage.getItem('id'));

  pesquisaParams = {
    Pagina: 0,
    TamanhoPagina: 20
  };

  tableColumns = [
    { header: 'Código da Saída', key: 'codigoSaida', type: 'text' },
    { header: 'Agendamento', key: 'agendamento', type: 'text' },
    { header: 'Entrada', key: 'entrada', type: 'text' },
    { header: 'Saída', key: 'saida', type: 'text' },
    { header: 'Placa do Cavalo', key: 'placaCavalo', type: 'text' },
    { header: 'Motorista', key: 'motorista', type: 'text' },
    { header: 'Empresa', key: 'empresa', type: 'text' },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.viewSaida(item)
        },
        {
          label: 'Download Ticket',
          img: 'assets/icon-download.svg',
          action: (item: any) => this.downloadTicket(Number(item.codigoSaida))
        },
        {
          label: 'Impressão Ticket',
          img: 'assets/icon-print.svg',
          action: (item: any) => this.imprimirTicket(Number(item.codigoSaida))
        }
      ]
    }
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private saidaGateService: SaidaGateService,
    private impressoraService: ImpressoraService,
    private appExportBase64: AppExportBase64,
    private reportService: ReportService
  ) { }

  private initForm() {
    const form = this.fb.group({
      CD_GATE_ENTR: [null],
      CD_EPSA: [null],
      NM_MTRT: [null],
      TX_PLCA_CAVA: [null],
      DT_INIC: [null],
      DT_FIM: [null]
    });
    return form;
  }

  editSaida(item: any) {
    const params = {
      ...item,
      isEditing: true
    };
    this.router.navigate(['cadastro/saida-gate'], {
      queryParams: params
    });
  }

  viewSaida(item: any) {
    const queryParams = {
      ...item,
      isViewing: true
    };
    this.router.navigate(['cadastro/saida-gate'], {
      queryParams: queryParams
    });
  }

  ngOnInit() {
    this.getSaidas();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getSaidas();
    });
  }

  navigateNovaSaida() {
    this.router.navigate(['cadastro/saida-gate']);
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.Pagina = pagina;
    this.numeroPagina = pagina;
    this.getSaidas(pagina + 1);
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === '' ? 'Não Informado' : String(campo);
  }

  getSaidas(pageNumber?: number) {
    this.isLoading = true;
    const params = {
      ...this.form.value,
      PAGE_NUMBER: pageNumber ?? 1,
      PAGE_SIZE: 8
    };
    this.saidaGateService.GetSaidas(params).subscribe({
      next: (res: IGetSaidasGate) => {
        this.tableData = res.ITEMS.map(item => {
          return {
            codigoSaida: item.CD_GATE_SAID,
            agendamento: item.DT_AGND,
            idEntrada: item.PK_GATE_ENTR,
            entrada: item.DT_ENTR_GATE,
            saida: item.DT_GATE_SAID,
            placaCavalo: formatarPlaca(item.TX_PLCA_CAVA),
            motorista: item.NM_MTRT,
            empresa: item.NM_EPSA ?? '---'
          };
        });
        this.maxPages = res.TOTAL_PAGES;
        this.isLoading = false;
      },
      error: (_error: any) => {
        this.isLoading = false;
      }
    });
  }

  downloadTicket(id: number) {
    this.isLoading = true;

    this.saidaGateService.GetReceiptGateSaidayId(id, 0).subscribe({
      next: (response: IGetReportBase64) => {
        this.appExportBase64.downloadPDF(response.ReportBase64, 'ticket');
        this.isLoading = false;
      },
      error: _error => {
        this.isLoading = false;
      }
    });
  }

  imprimirTicket(id: number) {
    this.isLoading = true;

    this.saidaGateService.GetReceiptGateSaidayId(id, 1).subscribe({
      next: async (response: IGetReportBase64) => {
        this.isLoading = false;
        const tickets = await decidirImpressaoPrePatio(response.ReportBase64);
        if (!tickets?.length) return;
        tickets.forEach((ticket, index) => {
          setTimeout(() => {
            this.impressoraService.impressoraTicket(ticket, 'text/plain');
          }, index * 1200);
        });
      },
      error: _error => {
        this.isLoading = false;
      }
    });
  }

  exportarExcel() {
    this.isLoading = true;

    const params = {
      ...this.form.value
    };

    this.reportService.GetSaidaGate(params).subscribe({
      next: (response: IGetReportBase64) => {
        this.appExportBase64.downloadExcel(response.ReportBase64, 'saida-gate');

        this.isLoading = false;
      },
      error: _error => {
        this.isLoading = false;
      }
    });
  }
}

